'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

exports.default = asyncWrapper;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _getDisplayName = require('../utils/getDisplayName');

var _getDisplayName2 = _interopRequireDefault(_getDisplayName);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
/**
 * Wrapper for Asynchronous Load of Baidu Map
 * @author terencewu
 */


function asyncWrapper(WrappedComponent) {
  var _class, _temp;

  return _temp = _class = function (_Component) {
    _inherits(Container, _Component);

    function Container(props) {
      _classCallCheck(this, Container);

      var _this = _possibleConstructorReturn(this, (Container.__proto__ || Object.getPrototypeOf(Container)).call(this, props));

      _this.isUnmounted = false;
      _this.handleLoaded = _this.handleLoaded.bind(_this);
      _this.state = {
        loading: true
      };
      return _this;
    }

    _createClass(Container, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        var _this2 = this;

        var _props = this.props,
            useScriptjs = _props.useScriptjs,
            mapUrl = _props.mapUrl;

        if (typeof BMap !== 'undefined') {
          this.handleLoaded();
          return;
        }

        if (useScriptjs) {
          var scriptjs = require('scriptjs'); // eslint-disable-line global-require


          scriptjs(mapUrl, this.handleLoaded);
        } else if (!window.initBaiduMap) {
          window.initBaiduMap = function () {
            _this2.handleLoaded();
          };

          var script = document.createElement('script');
          script.type = 'text/javascript';
          script.src = mapUrl + '&callback=initBaiduMap';
          document.body.appendChild(script);
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        this.isUnmounted = true;
      }
    }, {
      key: 'handleLoaded',
      value: function handleLoaded() {
        if (this.isUnmounted) {
          return;
        }

        this.setState({
          loading: false
        });
        var onMapSrcLoaded = this.props.onMapSrcLoaded;

        if (onMapSrcLoaded) {
          onMapSrcLoaded();
        }
      }
    }, {
      key: 'getWrappedInstance',
      value: function getWrappedInstance() {
        return this.refs['wrappedInstanceMap' + this.props.id]; // eslint-disable-line react/prop-types
      }
    }, {
      key: 'render',
      value: function render() {
        var _props2 = this.props,
            useScriptjs = _props2.useScriptjs,
            mapUrl = _props2.mapUrl,
            loadingElement = _props2.loadingElement,
            onMapSrcLoaded = _props2.onMapSrcLoaded,
            restProps = _objectWithoutProperties(_props2, ['useScriptjs', 'mapUrl', 'loadingElement', 'onMapSrcLoaded']);

        var loading = this.state.loading;

        if (!loading) {
          return _react2.default.createElement(WrappedComponent, _extends({
            ref: 'wrappedInstanceMap' + this.props.id
          }, restProps)); // eslint-disable-line react/prop-types
        }

        return loadingElement;
      }
    }]);

    return Container;
  }(_react.Component), _class.displayName = 'asyncWrapper(' + (0, _getDisplayName2.default)(WrappedComponent) + ')', _class.propTypes = {
    useScriptjs: _propTypes2.default.bool,
    mapUrl: _propTypes2.default.string.isRequired,
    loadingElement: _propTypes2.default.element.isRequired,
    onMapSrcLoaded: _propTypes2.default.func
  }, _class.defaultProps = {
    useScriptjs: false
  }, _temp;
}

module.exports = exports['default'];